var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H8C6.9 18 6 17.1 6 16V4C6 2.9 6.9 2 8 2ZM2 6H4V20H18V22H4C2.9 22 2 21.1 2 20V6ZM8 16V4H20V16H8ZM18 9H10V11H18V9ZM10 12H14V14H10V12ZM18 6H10V8H18V6Z",
    fill: "#56CD9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardGreen);
export default __webpack_public_path__ + "static/media/board-green.dac4a1da8d3c23424fc62eab6d6bb912.svg";
export { ForwardRef as ReactComponent };